// Minimalist Co (cobalt) periodic-table tile used as the brand
// mark. Inline SVG so it sizes off the surrounding font / line
// height and inherits the chrome's foreground / accent colours
// via the `currentColor` and explicit fill values. Width is set
// from the `size` prop; aspect ratio is locked at 1:1 by the
// viewBox.

interface LogoProps {
  /** Square pixel size; height matches. Defaults to 32. */
  size?: number;
}

export function Logo({ size = 32 }: LogoProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      role="img"
      aria-label="CoScience.Co"
    >
      <rect
        x="2"
        y="2"
        width="60"
        height="60"
        rx="10"
        fill="#0b132b"
        stroke="#4cc9f0"
        strokeWidth="2"
      />
      <text
        x="9"
        y="18"
        fill="#9ad8ff"
        fontFamily="ui-sans-serif, system-ui, -apple-system, sans-serif"
        fontSize="11"
        fontWeight={600}
      >
        27
      </text>
      <text
        x="32"
        y="44"
        fill="#f5f5f5"
        fontFamily="ui-sans-serif, system-ui, -apple-system, sans-serif"
        fontSize="28"
        fontWeight={700}
        letterSpacing="-0.5"
        textAnchor="middle"
      >
        Co
      </text>
      <text
        x="55"
        y="58"
        fill="#ff7a3a"
        fontFamily="ui-sans-serif, system-ui, -apple-system, sans-serif"
        fontSize="9"
        fontWeight={600}
        textAnchor="end"
      >
        .Co
      </text>
    </svg>
  );
}
